<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import PrescriptDetailComponent from "../../Common/PrescriptDetailComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    }
})
const listRef = ref();
const searchPatientName = ref('');
const searchMedicineName = ref('');
const onSearchPatientNameChange = (value) => {
  searchPatientName.value = value;
}
const onSearchPatientNameEnter = (value) => {
  searchPatientName.value = value;
  listSearch();
}
const onSearchMedicineNameChange = (value) => {
  searchMedicineName.value = value;
}
const onSearchMedicineNameEnter = (value) => {
  searchMedicineName.value = value;
  listSearch();
}
const todayPrescript = ref(true);
const onChangeTodayPrescript = (value) => {
  todayPrescript.value = value;
  listSearch();
}
const searchDateFrom = ref('');
const searchDateTo = ref('');
const isLoadingDialog = ref(false);
const optionFields = ref({
  'patient_name' : searchPatientName.value,
  'medicine_name' : searchMedicineName.value,
  'prescript_date_from':searchDateFrom.value,
  'prescript_date_to':searchDateTo.value,
  'is_today': (todayPrescript.value ? 1 : 0),
  'page_size' : 10,
});
const clearDate = () => {
  searchDateFrom.value = '';
  searchDateTo.value = '';
  listSearch();
}
const onSearchDateFromChange = (value) => {
  searchDateFrom.value = value;
  listSearch();
}
const onSearchDateToChange = (value) => {
  searchDateTo.value = value;
  listSearch();
}
const listSearch = () => {
  optionFields.value.patient_name = searchPatientName.value;
  optionFields.value.medicine_name = searchMedicineName.value;
  optionFields.value.prescript_date_from = searchDateFrom.value;
  optionFields.value.prescript_date_to = searchDateTo.value;
  optionFields.value.is_today = (todayPrescript.value ? 1 : 0);
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="pharmacy_prescript_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
      <div class="absolute top-2 left-2">
        <help-action
          help-key="order_help"
        ></help-action>
      </div>
      <div class="m-1">
        <check-box
          label="当日処方"
          :value="todayPrescript"
          :on-change="onChangeTodayPrescript"
        ></check-box>
      </div>
      <div class="m-1">
        <search-box
          :search-word="searchMedicineName"
          :on-change="onSearchMedicineNameChange"
          :on-enter="onSearchMedicineNameEnter"
          place-holder="採用品名を入力"
        ></search-box>
      </div>
      <div class="m-1">
        <search-box
          :search-word="searchPatientName"
          :on-change="onSearchPatientNameChange"
          :on-enter="onSearchPatientNameEnter"
          place-holder="患者名を入力"
        ></search-box>
      </div>
      <div class="m-1 flex flex-row items-center">
        <text-box
          :value="searchDateFrom"
          type="date"
          :on-change="onSearchDateFromChange"
          place-holder="日付を入力"
          :is-read-only="todayPrescript"
        ></text-box>
        <div class="tex-lg">~</div>
        <text-box
          :value="searchDateTo"
          type="date"
          :on-change="onSearchDateToChange"
          place-holder="日付を入力"
          :is-read-only="todayPrescript"
        ></text-box>
        <a @click="clearDate" class="block cursor-pointer m-1 text-lg text-red-500"><i class="fa-solid fa-calendar-xmark"></i></a>
      </div>
  </div>
  <div class="w-full">
    <prescript-detail-component
      :apis="apis"
      :option-fields="optionFields"
      :patientId="0"
    ></prescript-detail-component>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

</template>

